import { ReactNode } from 'react';
import classNames from 'classnames';
import css from './placeholder-card.module.css';

interface IPlaceholderCardProps {
  title: ReactNode;
  text: ReactNode;
}

const PlaceholderCard = ({ title, text }: IPlaceholderCardProps) => {
  return (
    <div className={css.placeholder}>
      <div className={css.circles}>
        <div className={classNames(css.circle, css.darkCircle)} />
        <div className={classNames(css.circle, css.lightCircle)} />
      </div>

      <div>
        <div className={css.placeholderTitle}>{title}</div>
        <div className={css.placeholderText}>{text}</div>
      </div>
    </div>
  );
};

export default PlaceholderCard;
